//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DpTableRow',
  props: {
    disabled: { type: Boolean, default: false },
  },
};
